import { FunctionComponent } from "react";

import * as Flags from "country-flag-icons/react/3x2";

import { classNames } from "@/utils/classNames";

import { LANGUAGE_COUNTRY_MAP } from "./types";

interface LanguageFlagProps {
	language: string;
	className?: string;
	title?: string;
}

/**
 * LanguageFlag — renders a solid (non-waved) SVG flag for a given ISO 639-1 language code.
 * Falls back to a globe emoji if the language has no mapped country.
 */
export const LanguageFlag: FunctionComponent<LanguageFlagProps> = ({
	language,
	className,
	title,
}) => {
	const countryCode = LANGUAGE_COUNTRY_MAP[language];
	const Flag = countryCode
		? (Flags as Record<string, FunctionComponent<{ title?: string; className?: string }>>)[
				countryCode
			]
		: undefined;

	if (!Flag) {
		return (
			<span aria-label={title} className={className} role="img">
				🌐
			</span>
		);
	}

	return <Flag className={classNames("inline-block", className)} title={title} />;
};
